// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
// Realtime custom elements (ADR-0013). `turbo_stream_from` in views emits
// <turbo-mercure-stream-source> and `mercure_data_from` emits
// <mercure-data-source>; both open a WebSocket to the topic's Durable Object.
// The comment this replaces still described the EventSource/Mercure-hub
// transport, which has not been the implementation since ADR-0013.
import "./realtime"
import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Import controllers
// Not imported, so not in the bundle: the five controllers only the exports
// surface mounted (Rails export_templates/index and steps/_columns and
// _output, data_exports/show): column-configurator, formula-builder,
// export-preview, export-confirm-delete and autoscroll. The exports surface is
// ruled dead (Bailey, 2026-09-25) and edge renders none of those views.
import ThemeController from "./controllers/theme_controller"
import DropdownController from "./controllers/dropdown_controller"
import FlashController from "./controllers/flash_controller"
import ModalController from "./controllers/modal_controller"
import ToggleController from "./controllers/toggle_controller"
import ToastController from "./controllers/toast_controller"
import SidebarController from "./controllers/sidebar_controller"
import PageSelectorController from "./controllers/page_selector_controller"
import ConditionBuilderController from "./controllers/condition_builder_controller"
import CollapseController from "./controllers/collapse_controller"
import CampaignSelectorController from "./controllers/campaign_selector_controller"
import UtmBuilderController from "./controllers/utm_builder_controller"
import TabsController from "./controllers/tabs_controller"
import ChartController from "./controllers/chart_controller"
import ReportFilterController from "./controllers/report_filter_controller"
import SortableTableController from "./controllers/sortable_table_controller"
import BillingController from "./controllers/billing_controller"
import AccountFilterController from "./controllers/account_filter_controller"
import NotificationsController from "./controllers/notifications_controller"
import AutoboostCardController from "./controllers/autoboost_card_controller"
import DisableOnSubmitController from "./controllers/disable_on_submit_controller"
import CampaignDropdownController from "./controllers/campaign_dropdown_controller"
import PageDropdownController from "./controllers/page_dropdown_controller"
import HistoryFilterController from "./controllers/history_filter_controller"
import EligiblePostsFilterController from "./controllers/eligible_posts_filter_controller"
import InsightsPageSelectorController from "./controllers/insights_page_selector_controller"
import InsightsScopeSelectorController from "./controllers/insights_scope_selector_controller"
import InsightGlowController from "./controllers/insight_glow_controller"
import WizardFooterController from "./controllers/wizard_footer_controller"
import BrandSelectionController from "./controllers/brand_selection_controller"
import NavActiveController from "./controllers/nav_active_controller"
import CodemirrorController from "./controllers/codemirror_controller"
import GuestNavbarController from "./controllers/guest_navbar_controller"
import NavbarBuilderController from "./controllers/navbar_builder_controller"
import PostInsightsController from "./controllers/post_insights_controller"
import AgentRunLogController from "./controllers/agent_run_log_controller"
import AgentTestRunController from "./controllers/agent_test_run_controller"
import MarkdownRendererController from "./controllers/markdown_renderer_controller"
import ClipboardController from "./controllers/clipboard_controller"
import FormLoadingController from "./controllers/form_loading_controller"
import CaptionPopoverController from "./controllers/caption_popover_controller"
import AdsPollerController from "./controllers/ads_poller_controller"
import AdsSectionController from "./controllers/ads_section_controller"
import ChangeDetectorController from "./controllers/change_detector_controller"
import FilterBuilderController from "./controllers/filter_builder_controller"
import VideoPreviewController from "./controllers/video_preview_controller"
import PlaygroundController from "./controllers/playground_controller"
import PixelSelectorController from "./controllers/pixel_selector_controller"
import CampaignCreatorController from "./controllers/campaign_creator_controller"
import TiktokCampaignCreatorController from "./controllers/tiktok_campaign_creator_controller"
import MetaSyncPollerController from "./controllers/meta_sync_poller_controller"
import TurboStreamLinkController from "./controllers/turbo_stream_link_controller"
import ThumbnailFallbackController from "./controllers/thumbnail_fallback_controller"
import ModalTriggerController from "./controllers/modal_trigger_controller"
import RemoteModalController from "./controllers/remote_modal_controller"
import EmailTemplatePreviewController from "./controllers/email_template_preview_controller"
import AutoboostRefreshController from "./controllers/autoboost_refresh_controller"
import TiktokRefreshController from "./controllers/tiktok_refresh_controller"
import NotificationActionController from "./controllers/notification_action_controller"
import LiveElapsedController from "./controllers/live_elapsed_controller"
import CheckAllController from "./controllers/check_all_controller"
import ChatBubbleController from "./controllers/chat_bubble_controller"
import ChatPanelController from "./controllers/chat_panel_controller"
import TranscribeController from "./controllers/transcribe_controller"
import SidebarGroupController from "./controllers/sidebar_group_controller"
import CuratorCarouselController from "./controllers/curator_carousel_controller"
import CuratorStreamController from "./controllers/curator_stream_controller"
import AdAccountPickerController from "./controllers/ad_account_picker_controller"
import RowExpanderController from "./controllers/row_expander_controller"
import RecommendationsController from "./controllers/recommendations_controller"

// Import dropzone
import DropzoneController from "./controllers/dropzone_controller"
import DataFrameController from "./controllers/data_frame_controller"

// Register controllers
application.register("theme", ThemeController)
application.register("dropdown", DropdownController)
application.register("flash", FlashController)
application.register("modal", ModalController)
application.register("toggle", ToggleController)
application.register("toast", ToastController)
application.register("sidebar", SidebarController)
application.register("page-selector", PageSelectorController)
application.register("condition-builder", ConditionBuilderController)
application.register("collapse", CollapseController)
application.register("campaign-selector", CampaignSelectorController)
application.register("utm-builder", UtmBuilderController)
application.register("tabs", TabsController)
application.register("chart", ChartController)
application.register("report-filter", ReportFilterController)
application.register("sortable-table", SortableTableController)
application.register("billing", BillingController)
application.register("account-filter", AccountFilterController)
application.register("notifications", NotificationsController)
application.register("autoboost-card", AutoboostCardController)
application.register("disable-on-submit", DisableOnSubmitController)
application.register("campaign-dropdown", CampaignDropdownController)
application.register("page-dropdown", PageDropdownController)
application.register("history-filter", HistoryFilterController)
application.register("eligible-posts-filter", EligiblePostsFilterController)
application.register("insights-page-selector", InsightsPageSelectorController)
application.register("insights-scope-selector", InsightsScopeSelectorController)
application.register("insight-glow", InsightGlowController)
application.register("wizard-footer", WizardFooterController)
application.register("brand-selection", BrandSelectionController)
application.register("nav-active", NavActiveController)
application.register("codemirror", CodemirrorController)
application.register("guest-navbar", GuestNavbarController)
application.register("navbar-builder", NavbarBuilderController)
application.register("post-insights", PostInsightsController)
application.register("agent-run-log", AgentRunLogController)
application.register("agent-test-run", AgentTestRunController)
application.register("markdown-renderer", MarkdownRendererController)
application.register("clipboard", ClipboardController)
application.register("form-loading", FormLoadingController)
application.register("autoboost-refresh", AutoboostRefreshController)
application.register("notification-action", NotificationActionController)
application.register("caption-popover", CaptionPopoverController)
application.register("ads-poller", AdsPollerController)
application.register("ads-section", AdsSectionController)
application.register("change-detector", ChangeDetectorController)
application.register("filter-builder", FilterBuilderController)
application.register("video-preview", VideoPreviewController)
application.register("playground", PlaygroundController)
application.register("pixel-selector", PixelSelectorController)
application.register("campaign-creator", CampaignCreatorController)
application.register("tiktok-campaign-creator", TiktokCampaignCreatorController)
application.register("tiktok-refresh", TiktokRefreshController)
application.register("meta-sync-poller", MetaSyncPollerController)
application.register("turbo-stream-link", TurboStreamLinkController)
application.register("thumbnail-fallback", ThumbnailFallbackController)
application.register("modal-trigger", ModalTriggerController)
application.register("remote-modal", RemoteModalController)
application.register("email-template-preview", EmailTemplatePreviewController)
application.register("live-elapsed", LiveElapsedController)
application.register("check-all", CheckAllController)
application.register("chat-bubble", ChatBubbleController)
application.register("chat-panel", ChatPanelController)
application.register("transcribe", TranscribeController)
application.register("sidebar-group", SidebarGroupController)
application.register("curator-carousel", CuratorCarouselController)
application.register("curator-stream", CuratorStreamController)
application.register("ad-account-picker", AdAccountPickerController)
application.register("row-expander", RowExpanderController)
application.register("recommendations", RecommendationsController)
application.register("dropzone", DropzoneController)
application.register("data-frame", DataFrameController)

// AB-048: boot log — runs after a microtask so all register() calls have
// actually populated the router's module map before we read the count.
queueMicrotask(() => {
  const modules = application.router.modules || []
  const identifiers = modules.map(m => m.definition?.identifier).filter(Boolean)
  console.log(`[stimulus] boot: ${identifiers.length} controllers registered`)
  console.log(`[stimulus] controllers:`, identifiers)
})
document.addEventListener("turbo:load", () => console.log(`[turbo] turbo:load fired — url=${location.pathname}`))
document.addEventListener("turbo:before-stream-render", (e) => console.log(`[turbo] before-stream-render action=${e.target.action} target=${e.target.target}`))
document.addEventListener("turbo:submit-end", (e) => console.log(`[turbo] submit-end form=${e.target.action}`))

export { application }
